import { useGLTF } from '@react-three/drei';
import React from 'react';

export default function Sofa({ scale = [20, 20, 20], ...props }) {
  const { scene } = useGLTF('/sheensofa.glb'); // Load the model
  return <primitive object={scene} scale={scale} {...props} />;
}
